import { render, staticRenderFns } from "./AppCarouselTeamItem.vue?vue&type=template&id=8aaa4d9a"
import script from "./AppCarouselTeamItem.vue?vue&type=script&lang=js"
export * from "./AppCarouselTeamItem.vue?vue&type=script&lang=js"
import style0 from "./AppCarouselTeamItem.vue?vue&type=style&index=0&id=8aaa4d9a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports